/**
 *  Initialize sponsor detail
 */

var sponsorDetail = (function() {
  var pub = {}; // public facing functions

  pub.init = function() {
    var $sponsorCards = $('.sponsor-card,.partner-card');

    $sponsorCards.find('.sponsor-card__image,.partner-card__image').on("click", function() {
      var $sponsorCard = $(this).closest('.sponsor-card,.partner-card');

      if ($sponsorCard.hasClass('is-active')) {
        hideDetail($sponsorCard);
      } else {
        showDetail($sponsorCard);
      }

      $sponsorCards
        .not($sponsorCard)
        .filter('.is-active')
        .each(function(i, el) {
          hideDetail($(el));
        });
    });

    $sponsorCards.find('.sponsor-detail__close').on("click", function() {
      var $sponsorCard = $(this).closest('.sponsor-card,.partner-card');

      hideDetail($sponsorCard);
    });
  };

  function showDetail($sponsorCard) {
    var paddingBottom =
      $sponsorCard.find('.sponsor-detail').height() -
      ($sponsorCard.find('figcaption:visible').height() || 0) * 2;

    $sponsorCard.addClass('is-active');
    $sponsorCard.css('padding-bottom', paddingBottom);
  }

  function hideDetail($sponsorCard) {
    $sponsorCard.removeClass('is-active');
    $sponsorCard.css('padding-bottom', '');
  }

  return pub;
})();
